import React, { ReactElement } from 'react'

import { WrapPageElementNodeArgs } from 'gatsby'

import Layout from '@components/modules/global/layout'

import { ThemeProvider, GlobalStyles } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'

import GlobalTextProvider from '@system/providers/GlobalTextProvider'
import LangSwitchProvider from '@system/providers/LangSwitchProvider'
import PageContextProvider from '../providers/PageContextProvider'
import TrackingProvider from '@system/providers/TrackingProvider'

import theme from '@config/theme'

type PageWrapperProps = WrapPageElementNodeArgs & {
  props: {
    pageContext: BASE.Helpers.IPageContext
    location: Record<string, boolean>
  }
}

export default function PageWrapper({
  element,
  props,
}: PageWrapperProps): ReactElement {
  const darkTheme =
    props.pageContext.page?.darkTheme &&
    props.pageContext.page?.darkTheme === 'true'
      ? true
      : false

  return (
    <React.Fragment>
      <ThemeProvider theme={{ ...theme, darkTheme }}>
        {darkTheme && (
          <GlobalStyles
            styles={{
              body: {
                background: `${theme.palette.common.black} !important`,
                color: `${theme.palette.common.white} !important`,
              },
            }}
          />
        )}
        <TrackingProvider {...props}>
          <CssBaseline />
          <PageContextProvider pageContext={props.pageContext}>
            <GlobalTextProvider>
              <LangSwitchProvider>
                <Layout>{element}</Layout>
              </LangSwitchProvider>
            </GlobalTextProvider>
          </PageContextProvider>
        </TrackingProvider>
      </ThemeProvider>
    </React.Fragment>
  )
}
